var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"sm10":"","md10":"","lg10":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }